<template>
  <div>
    <DefaultContract/>
    <side-drawer>
      <template slot="formDetails">
        <!-- <contract-form/> -->
      </template>
    </side-drawer>
  </div>
</template>

<script>
export default {
  components: {
    "side-drawer": () => import("@/core/components/SideDrawer"),
    'DefaultContract': () => import("@/contract/components/DefaultContract.vue"),
    // 'contract-form': () => import("@/contract/components/rightSideDrawer/ContractForm.vue"),
  }
}
</script>

<style>

</style>